export default __webpack_public_path__ + "static/media/john-lennon.eb1ffe86.png";